import React, { Component, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import getUsersList from '../../api/graphql/queries/getUsersList';

class AutocompleteArrayUsers extends Component {
  state = {
    // The active selection's index
    activeSuggestion: 0,
    // The suggestions that match the user's input
    filteredSuggestions: [],
    // Whether or not the suggestion list is shown
    showSuggestions: false,
    // What the user has entered
    userInput: '',
  };

  componentDidMount() {
    const { value } = this.props;
    if (value) {
      this.setState({
        userInput: value,
      });
    }
    return null;
  }

  searchUser = async (e) => {
    const { value } = e.target;
    if (value === '') return [];
    const res = await getUsersList({
      active: true,
      email: value,
    });
    if (res === null) return [];
    return res;
  };

  onChange = async (e) => {
    const userInput = e.currentTarget.value;
    this.setState({ userInput });
    if (userInput.length < 4) return;
    const { users, total} = await this.searchUser(e);
    const suggestions = await users.map(i => i.email);
    // const { suggestions } = this.props;

    // Filter our suggestions that don't contain the user's input
    const filteredSuggestions = (await suggestions) && suggestions.filter(suggestion => suggestion && suggestion.indexOf(userInput) > -1);

    this.setState({
      activeSuggestion: 0,
      filteredSuggestions,
      showSuggestions: true,
    });
    const { storeValue } = this.props;
    storeValue(userInput);
  };

  onClick = (e) => {
    const userInput = e.currentTarget.innerText;
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: e.currentTarget.innerText,
    });
    const { storeValue } = this.props;
    storeValue(userInput);
  };

  render() {
    const {
      onChange,
      onClick,
      state: {
        activeSuggestion, filteredSuggestions, showSuggestions, userInput,
      },
    } = this;

    const {
      message, title, value, isLocked, textColor,
    } = this.props;

    let suggestionsListComponent;

    if (showSuggestions && userInput) {
      if (filteredSuggestions && filteredSuggestions.length) {
        suggestionsListComponent = (
          <ul className="list-none mt-0 pl-0" style={{ overflowY: 'auto', width: 'calc(300px + 1 rem)' }}>
            {filteredSuggestions.map((suggestion, index) => {
              let className;

              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = 'cursor-pointer';
              }

              return (
                <li className={`${className} p-2 hover:text-black hover:bg-white `} key={suggestion} onClick={onClick}>
                  {suggestion}
                </li>
              );
            })}
          </ul>
        );
      } else {
        suggestionsListComponent = (
          <div className="no-suggestions">
            <em>{message}</em>
          </div>
        );
      }
    }

    return (
      <Fragment>
        <div className="flex flex-col font-americaMonoRegular text-xs mb-2 ">
          <input type="text" onChange={onChange} value={userInput} className="mt-2 rounded-full border-1 p-2 bg-white text-black outline-none" disabled={isLocked} />
          {suggestionsListComponent}
        </div>
      </Fragment>
    );
  }
}

AutocompleteArrayUsers.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  message: PropTypes.string.isRequired,
  storeValue: PropTypes.func.isRequired,
  isLocked: PropTypes.bool,
  textColor: PropTypes.string,
};

AutocompleteArrayUsers.defaultProps = {
  value: '',
  isLocked: false,
  suggestions: [],
  textColor: 'white',
};

export default AutocompleteArrayUsers;
